export default __webpack_public_path__ + "static/media/albufeira66pic1.68f3ccea.jpg";